import * as React from 'react';
import SmilesIconPath from './SmilesIconPath';

interface IProps {
  fillColor?: string;
}

export default function SmilesIcon(props: IProps) {
  return <svg width="12px" height="12px" viewBox="0 0 12 12" version="1.1" className="smiles-icon">
    <SmilesIconPath fillColor={props.fillColor} />
  </svg>;
}



// WEBPACK FOOTER //
// ./src/components/icons/SmilesIcon.tsx